import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';

import useStyles from '../useStyles';

const data = { type: 'sortableListItem' };

const SortableItem = ({ id, caret, disabled, children }) => {
  const classes = useStyles();
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id, data, disabled });

  // No transform/transition on purpose: items stay static and the caret marks the drop slot.
  return (
    <li
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={classnames(classes.item, {
        [classes.caretBefore]: caret === 'before',
        [classes.caretAfter]: caret === 'after',
        [classes.dragging]: isDragging,
      })}
    >
      {children}
    </li>
  );
};

SortableItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  caret: PropTypes.oneOf(['before', 'after']),
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

SortableItem.defaultProps = {
  caret: null,
  disabled: false,
  children: null,
};

export default SortableItem;
